const CATEGORIES = [
  {
    id: 'tatlılar',
    label: 'Tatlılar & Pastalar',
    icon: '🍰',
    subcategories: [
      { id: 'baklava', label: 'Baklava Çeşitleri' },
      { id: 'kunefe', label: 'Künefe & Katmer' },
      { id: 'pasta', label: 'Pasta & Cheesecake' },
      { id: 'diger-tatlilar', label: 'Diğer Tatlılar' }
    ]
  },
  {
    id: 'hamur-isleri',
    label: 'Hamur İşi & Börek',
    icon: '🥐',
    subcategories: [
      { id: 'borek', label: 'Börekler' },
      { id: 'pide-lahmacun', label: 'Pide & Lahmacun' },
      { id: 'ekmek-simit', label: 'Ekmek, Simit & Açma' },
      { id: 'yufka-lavash', label: 'Yufka & Lavaş' }
    ]
  },
  {
    id: 'ana-yemekler',
    label: 'Geleneksel Ana Yemekler',
    icon: '🍲',
    subcategories: [
      { id: 'manti-kofte', label: 'Mantı & Köfte' },
      { id: 'sarma-dolma', label: 'Sarma & Dolma' },
      { id: 'et-urunleri', label: 'Et Ürünleri' },
      { id: 'meze', label: 'Meze & Hafif Yemekler' }
    ]
  },
  {
    id: 'dondurma-pasta',
    label: 'Dondurma & Soğuk Tatlılar',
    icon: '🍦',
    subcategories: [
      { id: 'dondurma', label: 'Maraş Dondurması' },
      { id: 'soguk-pasta', label: 'Soğuk Pasta & Cheesecake' }
    ]
  },
  {
    id: 'bakkaliye',
    label: 'Bakkaliye & Tahıllar',
    icon: '🫙',
    subcategories: [
      { id: 'zeytinyagi', label: 'Zeytinyağı' },
      { id: 'tahillar', label: 'Tahıllar & Bakliyat' }
    ]
  }
];

export default CATEGORIES;
